<template>
  <div class="templ-container">
    <div class="login-inner">
      <div class="login-content">
        <div class="left-container">
          <slot></slot>
        </div>

        <div class="right-container">
          <!-- <p class="title">DCP APP</p> -->
          <div class="login-video-wrap">
            <video
              id="my-player"
              class="video video-js vjs-big-play-centered"
              controls
              preload="auto"
              data-setup="{}"
              playsinline
              webkit-playsinline
              x5-video-player-type="h5"
              x5-video-player-fullscreen
              poster="../../assets/img/video-poster.png"
            >
              <source :src="videoUrl" type="video/mp4"></source>
            </video>
            <!-- <img src="../../assets/img/video-placeholder.png" alt="" class="video-placeholder"> -->
          </div>
          <div :class="`qr-wrap ${env === 'uat' ? 'hidden' : ''}`">
            <div class="qr-item">
              <div class="qr">
                <img :src="require(`../../assets/img/download-nt-${env}.png`)" alt="" class="qr-img">
              </div>
              <p>米其林版</p>
            </div>
            <div class="qr-item">
              <div class="qr">
                <img :src="require(`../../assets/img/download-tp-${env}.png`)" alt="" class="qr-img">
              </div>
              <p>驰加版</p>
            </div>
          </div>
          <p class="tips">支持热线：400 6033 626</p>
          <p class="tips">渠道热线：400 1011 168<span class="tip-time">（周一至周日：8:00-19:00）</span></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'LoginTempl',
  data() {
    return {
      env: process.env.VUE_APP_ENV
    }
  },
  computed: {
    videoUrl() {
      return `${process.env.VUE_APP_DCC_STATIC_URL}dcp.mp4`
    }
  },
  watch: { },
  mounted() { },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.templ-container {
  width: 100%;
  height: 100%;
  // overflow: auto;
}

.login-inner {
  // position: absolute;
  // top: 50%;
  // width: 100%;
  // height: auto;
  // transform: translateY(-50%);
  // margin: calc((100vh - 760px - #{$footerHeight}) / 2) auto 0;
  padding-top: calc((100vh - 760px - #{$footerHeight}) / 2);
}

.login-content {
  position: relative;
  display: flex;
  justify-content: space-between;
  // align-items: center;
  width: 1068px;
  height: 760px;
  margin: 0 auto;
  // background: url('../../assets/img/login-bg.png') no-repeat right bottom;
  // background-size: auto 240px;
  box-shadow: 0 1px 17px 0 rgba(0, 0, 0, 0.1);
}

.left-container {
  flex: 1;
  padding-top: 90px;
  text-align: center;
}

.right-container {
  width: 380px;
  padding-top: 130px;
  color: #000;

  .title {
    font-weight: 600;
    font-size: 20px;
  }

  .qr-wrap {
    display: flex;
    justify-content: flex-start;
    margin: 40px 0;
    font-weight: 600;
    font-size: 14px;

    &.hidden {
      opacity: 0;
      height: 0px;
    }

    .qr-item {
      text-align: center;

      + .qr-item {
        margin-left: 20px;
      }

      .qr {
        width: 130px;
        height: 130px;
        margin-bottom: 10px;
        background: #f4f4f4;

        .qr-img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .tips {
    font-size: 16px;
    line-height: 2;

    .tip-time {
      font-size: 12px;
    }
  }
}

.login-video-wrap {
  position: relative;
  left: -50px;
  // width: 100%;
  // width: 1920/1080*200px;
  width: 380px;
  // height: 200px;
  height: 1080/1920*380px;
  box-shadow: 0 1px 17px 0 rgba(0, 0, 0, 0.1);

  .video {
    width: 100%;
    height: 100%;
  }

  .video-placeholder {
    position: absolute;
    top: 50%;
    left: 50%;
    width: auto;
    height: 100px;
    transform: translate(-50%, -50%);
  }
}
</style>

<style lang="scss">
.login-video-wrap {
  .vjs-poster {
    background-size: 100% 100%;
  }
}
</style>
